import React, { useEffect, useState } from "react";
import { Filter } from "lucide-react";
import api from "../../lib/api";

const LABELS = { signup_completed: "Inscrits", property_created: "Bien", tenant_created: "Locataire", lease_created: "Bail", receipt_generated: "Quittance" };

export const ActivationFunnel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/activation-funnel?weeks=12").then((r) => setD(r.data)).catch(() => setD({ cohorts: [], steps: [] })); }, []);
  if (!d) return null;
  return (
    <div className="bg-white rounded-2xl border border-brand-soft p-6" data-testid="activation-funnel">
      <h3 className="font-semibold text-brand-greenDeep flex items-center gap-2"><Filter className="w-4 h-4" /> Entonnoir d'activation (par semaine d'inscription)</h3>
      <p className="text-xs text-brand-green/50 mt-1">Indicateur nord : part des inscrits ayant créé un bail dans les 7 jours. Les données d'exemple ne sont pas comptées.</p>
      {!d.cohorts.length ? <p className="text-sm text-brand-green/50 mt-4" data-testid="funnel-empty">Aucune inscription suivie pour l'instant : les données apparaîtront avec les prochains inscrits.</p> : (
        <div className="overflow-x-auto mt-4">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-brand-green/50">
              <th className="py-2 pr-4">Semaine</th>{d.steps.map((s) => <th key={s} className="py-2 pr-4 text-right">{LABELS[s]}</th>)}
              <th className="py-2 pr-4 text-right">Activation 7 j</th><th className="py-2 text-right">Délai médian → bail</th>
            </tr></thead>
            <tbody>
              {d.cohorts.map((c) => (
                <tr key={c.week} className="border-t border-brand-soft" data-testid={`funnel-row-${c.week}`}>
                  <td className="py-2 pr-4 whitespace-nowrap">{new Date(c.week).toLocaleDateString("fr-FR")}</td>
                  {d.steps.map((s) => <td key={s} className="py-2 pr-4 text-right">{c[s]} <span className="text-[11px] text-brand-green/40">{c.rates[s]} %</span></td>)}
                  <td className="py-2 pr-4 text-right font-semibold text-brand-greenDeep">{c.activation_rate} %</td>
                  <td className="py-2 text-right">{c.median_hours_to_lease == null ? "—" : c.median_hours_to_lease < 48 ? `${c.median_hours_to_lease} h` : `${Math.round(c.median_hours_to_lease / 24)} j`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const FIELDS = ["address", "type", "city", "postal_code", "surface", "rooms", "rent", "energy_class", "owner_id", "photos"];
export const completeness = (p) => Math.round(FIELDS.filter((k) => (Array.isArray(p[k]) ? p[k].length : p[k] && p[k] !== 0)).length / FIELDS.length * 100);
